import React, { useState, useEffect } from 'react';
import { Calendar, Upload, Image, FileText, Save, Eye } from 'lucide-react';
import '../css/Locations.css';
import axios from 'axios';
const Locations = () => {
  const [formData, setFormData] = useState({
    imageUrl: null,
    title: '',
    description: '',
    mapurl: null,
  });
  const [loc, setLoc] = useState([]);
  const [locPreview, setLocPreview] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageUpload = async (e) => {
  const file = e.target.files[0];  // Only the selected image
  console.log('image file', file);
  const imagedata = new FormData();
  imagedata.append('file', file);   // Upload just the file
  imagedata.append('upload_preset', 'unsigned_upload'); // Preset needed by Cloudinary
  console.log('imagedata', imagedata);
  const res = await fetch('https://api.cloudinary.com/v1_1/dccuq6ut4/upload', {
    method: 'POST',
    body: imagedata,
  });

  const data = await res.json();
  console.log('Uploaded Location Image URL:', data.secure_url); // ← You can now use this URL
  setFormData(prev => ({
        ...prev,
        imageUrl: data.secure_url
      }));
    
    const reader = new FileReader();
      reader.onload = (e) => {
        const preview = e.target.result;
        setLocPreview(preview);
        console.log('locpreview', preview);
      };
      reader.readAsDataURL(file);


};

useEffect(() => {
  console.log("locPreview changed:", locPreview);
}, [locPreview]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('entered submit');
    setIsSubmitting(true);
    try {
        const res = await axios.post('/api/locations', formData);
         setLoc(res.data);
        alert('Location added successfully!');
      } catch (error) {
        console.error("Error fetching members:", error);
        
    }
    setTimeout(() => {
      
      setIsSubmitting(false);
      setFormData({
        title: '',
        description: '',
       
        loc: null,
        mapurl: '',
      });
      setLocPreview(null);
      setShowPreview(false);
    }, 2000);
  };

  const isFormValid =
    formData.title.trim() &&
    formData.description.trim() &&
    
    formData.imageUrl && formData.mapurl;

  return (
    <div className='locContainer'>
      <div className='locWrapper'>
        <div className='locCard'>
          <div className='locHeader'>
            <h1 className='locHeaderTitle'>
              <FileText size={30} /> Add New Location
            </h1>
            <p className='locHeaderSubtext'>
              Fill in the details below 
            </p>
          </div>

          <div className='locContent'>
            {/* Title */}
            <div>
              <label className='locLabel'>Location Name *</label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                placeholder="Eg: Head Office, Irinjikula"
                //style={styles.}
                className='locInput'
              />
            </div>

            {/* Date */}
            {/* <div>
              <label style={styles.label}>
                <Calendar size={16} style={{ marginRight: 6 }} />
                Publication Date *
              </label>
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleInputChange}
                style={styles.input}
              />
            </div> */}

            {/* Image Upload */}
            <div>
              <label className='locLabel'>
                <Image size={16} style={{ marginRight: 6 }} />
                Featured Image *
              </label>
              <div className='locUploadBox'>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleImageUpload(e)}
                  id="image-upload"
                  style={{ display: 'none' }}
                />
                <label htmlFor="image-upload" className='locUploadLabel'>
                  {locPreview ? (
                    <div style={{ position: 'relative' }}>
                      <img
                        src={locPreview}
                        alt="Preview"
                        style={styles.imagePreview}
                        className='locImagePreview'
                      />
                      <div className='locImageOverlay'>
                        <Upload size={24} color="#fff" />
                      </div>
                    </div>
                  ) : (
                    <div style={{ textAlign: 'center' }}>
                      <Upload size={40} color="#aaa" />
                      <p className='locUploadText'>Click to upload image</p>
                      <p className='locUploadSubtext'>PNG, JPG, GIF up to 10MB</p>
                    </div>
                  )}
                </label>
              </div>
              {formData.imageUrl && (
                <p className='locSuccessText'>✓ {formData.imageUrl.name} uploaded</p>
              )}
            </div>

            {/* Description */}
            <div>
              <label style={styles.label}>Location description *</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                placeholder="Write your location description here"
                rows="12"
                style={{ resize: 'vertical' }}
                className='locInput'
              />
              <p className='locCharCount'>
                {formData.description.length} characters
              </p>
            </div>

             <div>
              <label className='locLabel'>Map URL *</label>
              <input
                type="url"
                name="mapurl"
                value={formData.mapurl}
                onChange={handleInputChange}
                placeholder="https://maps.app.goo.gl/xyz"
                //style={styles.input}
                className='locInput'
              />
            </div>

            {/* Preview Toggle */}
            <div>
              <button
                onClick={() => setShowPreview(!showPreview)}
                style={{
                  //...styles.toggleBtn,
                  opacity: isFormValid ? 1 : 0.5,
                  cursor: isFormValid ? 'pointer' : 'not-allowed'
                }}
                disabled={!isFormValid}
                className='locToggleBtn'
              >
                <Eye size={16} style={{ marginRight: 6 }} />
                {showPreview ? 'Hide Preview' : 'Show Preview'}
              </button>
            </div>

            {/* Preview */}
            {showPreview && isFormValid && (
              <div className='locPreviewBox'>
                <h3 className='locPreviewHeading'>Preview</h3>
                <div className='locPreviewCard'>
                  <h2 className='locPreviewTitle'>{formData.title}</h2>
                  <p className='locPreviewDate'>{formData.date}</p>
                  {locPreview && (
                    <img
                      src={locPreview}
                      alt="Preview"
                      //style={styles.previewImage}
                      className='locPreviewImage'
                    />
                  )}
                  {formData.description.split('\n').map((paragraph, idx) => (
                    <p key={idx} className='locPreviewText'>{paragraph}</p>
                  ))}
                </div>
              </div>
            )}

            {/* Submit Button */}
            <div className='locSubmitBox'>
              <button
                type="button"
                onClick={(e) => handleSubmit(e)}
                disabled={!isFormValid || isSubmitting}
                style={{
                  //...styles.,
                  background: isFormValid && !isSubmitting
                    ? 'linear-gradient(to right, #2563eb, #7c3aed)'
                    : '#aaa',
                  cursor: !isFormValid || isSubmitting ? 'not-allowed' : 'pointer'
                }}
                className='locSubmitBtn'
              >
                {isSubmitting ? (
                  <>
                    <div 
                    //style={styles.spinner} 
                    className='locSpinner'></div>
                    Publishing...
                  </>
                ) : (
                  <>
                    <Save size={20} />
                    Publish Location
                  </>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Form Status */}
        <div className='locStatusBox'>
          <h3 className='locStatusTitle'>Form Status</h3>
          <div className='locStatusGrid'>
            {[ 'imageUrl', 'title', 'description', 'mapurl'].map((field) => (
              <div
                key={field}
                style={{
                  //...styles.statusItem,
                  color: formData[field] ? '#16a34a' : '#999'
                }}
               className='locStatusItem'
              >
                <div
                  style={{
                    //...styles.statusDot,
                    backgroundColor: formData[field] ? '#16a34a' : '#ccc'
                  }}
                  className='locStatusDot'
                />
                <span className='locStatusLabel'>{field.charAt(0).toUpperCase() + field.slice(1)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f9fafb',
    padding: '2rem',
  },
  wrapper: {
    maxWidth: '960px',
    margin: '0 auto',
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: '1rem',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    overflow: 'hidden',
  },
  header: {
    background: 'linear-gradient(to right, #2563eb, #7c3aed)',
    color: '#fff',
    padding: '2rem',
  },
  headerTitle: {
    fontSize: '1.75rem',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
  },
  headerSubtext: {
    color: '#c7d2fe',
    marginTop: '0.5rem',
  },
  content: {
    padding: '2rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
  },
  label: {
    display: 'block',
    fontSize: '0.95rem',
    fontWeight: '600',
    marginBottom: '0.5rem',
  },
  input: {
    width: '100%',
    padding: '0.75rem',
    border: '2px solid #e5e7eb',
    borderRadius: '0.5rem',
    fontSize: '1rem',
    outline: 'none',
  },
  uploadBox: {
    border: '2px dashed #ccc',
    padding: '1.5rem',
    borderRadius: '1rem',
    cursor: 'pointer',
    textAlign: 'center',
    position: 'relative',
  },
  uploadLabel: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  uploadText: {
    fontSize: '1rem',
    fontWeight: '500',
    color: '#444',
  },
  uploadSubtext: {
    fontSize: '0.85rem',
    color: '#888',
  },
  imagePreview: {
    maxWidth: '300px',
    maxHeight: '200px',
    borderRadius: '0.5rem',
    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
  },
  imageOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.4)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0.5rem',
    opacity: 0,
    transition: 'opacity 0.3s ease',
  },
  successText: {
    marginTop: '0.5rem',
    color: '#16a34a',
    fontWeight: '500',
    fontSize: '0.9rem',
  },
  charCount: {
    fontSize: '0.85rem',
    color: '#666',
    marginTop: '0.5rem',
  },
  toggleBtn: {
    padding: '0.5rem 1rem',
    backgroundColor: '#eee',
    border: 'none',
    borderRadius: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    fontWeight: '500',
  },
  previewBox: {
    border: '2px solid #ddd',
    borderRadius: '0.75rem',
    padding: '1.5rem',
    backgroundColor: '#f3f4f6',
  },
  previewHeading: {
    fontSize: '1.1rem',
    fontWeight: '600',
    marginBottom: '1rem',
    color: '#444',
  },
  previewCard: {
    backgroundColor: '#fff',
    padding: '1.5rem',
    borderRadius: '0.75rem',
    boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
  },
  previewTitle: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '0.5rem',
  },
  previewDate: {
    color: '#666',
    marginBottom: '1rem',
  },
  previewImage: {
    width: '100%',
    height: '260px',
    objectFit: 'cover',
    borderRadius: '0.5rem',
    marginBottom: '1rem',
  },
  previewText: {
    color: '#444',
    lineHeight: '1.6',
    marginBottom: '1rem',
  },
  submitBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '2rem',
    borderTop: '1px solid #eee',
    paddingTop: '1.5rem',
  },
  submitBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0.75rem 1.5rem',
    fontSize: '1rem',
    color: '#fff',
    border: 'none',
    borderRadius: '0.5rem',
    fontWeight: '600',
    transition: 'all 0.3s ease',
  },
  spinner: {
    width: '1.25rem',
    height: '1.25rem',
    border: '2px solid white',
    borderTop: '2px solid transparent',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  statusBox: {
    marginTop: '2rem',
    backgroundColor: '#fff',
    padding: '1.5rem',
    borderRadius: '0.75rem',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
  },
  statusTitle: {
    fontWeight: '600',
    color: '#333',
    marginBottom: '1rem',
  },
  statusGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '1rem',
  },
  statusItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    fontSize: '0.85rem',
  },
  statusDot: {
    width: '0.5rem',
    height: '0.5rem',
    borderRadius: '999px',
  },
  statusLabel: {
    fontSize: '0.85rem',
  }
};

export default Locations;
